export class Mask {

  money(value: string | number) {
    value = value + ""
    value = parseInt(value.replace(/[\D]+/g, ""))
    value = value + ""
    value = value.replace(/([0-9]{2})$/g, ",$1")

    if (value.length > 6) {
      value = value.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2")
    }
    if (value === "NaN") {
      return ""
    } else {
      return value
    }
  }

  cpf_cnpj(value?: string | null) {
    if (!value) value = ""
    value = value.replace(/\D/g, "")

    value = value.slice(0, 14)

    if (!value) return ""

    const isCPF = value.length <= 11

    if (isCPF) {
      return value
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    } else {
      return value
        .replace(/^(\d{2})(\d)/, "$1.$2")
        .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/\.(\d{3})(\d)/, ".$1/$2")
        .replace(/(\d{4})(\d)/, "$1-$2")
    }
  }

  removeCpfCnpjMask = (value: string): string => {
    const isCpfCnpj = /^[\d./\-\s]+$/.test(value.trim())
    return isCpfCnpj ? value.replace(/\D/g, "") : value
  }

  phone = (value: string): string => {
    if (!value) value = ""
    value = value.replace(/\D/g, "")

    if (value.length === 10) {
      value = value.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3")
    } else if (value.length === 11) {
      value = value.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3")
    } else if (value.length > 11 || value.length < 15) {
      value = value.slice(0, 11)
      value = value.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3")
    }

    return value
  }

  cep = (value: string): string => {
    if (!value) value = ""
    value = value.replace(/\D/g, "")
    value = value.slice(0, 8)
    value = value.replace(/^(\d{5})(\d)/, "$1-$2")
    return value
  }
}